import React from "react";

interface Requirement {
  label: string
  check: (password: string) => boolean
}

export const RequirementAlgs = {
  oneUppercase: (value: string) => /[A-Z]/.test(value),
  oneLowercase: (value: string) => /[a-z]/.test(value),
  oneNumber: (value: string) => /[0-9]/.test(value),
  minLength: (value: string, length = 8) => value.length >= length,
  oneNonAlpha: (value: string) => /[^a-zA-Z0-9]/.test(value)
};

const MIN_PASSWORD_LENGTH = 10;

const PASSWORD_REQUIREMENTS: Requirement[] = [
  {
    label: "At least one uppercase character [A-Z]",
    check: (password: string) => RequirementAlgs.oneUppercase(password)
  },
  {
    label: "At least one lowercase character [a-z]",
    check: (password: string) => RequirementAlgs.oneLowercase(password)
  },
  {
    label: "At least one number [0-9]",
    check: (password: string) => RequirementAlgs.oneNumber(password)
  },
  {
    label: "At least one non-alphanumeric character",
    check: (password: string) => RequirementAlgs.oneNonAlpha(password)
  },
  {
    label: `Minimum of ${MIN_PASSWORD_LENGTH} characters`,
    check: (password: string) => RequirementAlgs.minLength(password, MIN_PASSWORD_LENGTH)
  }
];

export const PasswordRequirements = (props: { password?: string }) => {
  const { password } = props;
  const fontStyle = (passedTest: boolean) => passedTest ? {} : { color: "red" };
  return (
    <p>
      Password requirements: <br />
      {PASSWORD_REQUIREMENTS.map(({ label, check }) => (
        <span style={password ? fontStyle(check(password)) : {}}>- {label} <br /></span>
      ))}
    </p>
  );
};

export const validatePassword = (password: string) =>
  PASSWORD_REQUIREMENTS.every(({ check }) => check(password));
